import {useTranslation} from "react-i18next";
import { v4 as uuidv4 } from 'uuid';

export default function InterestedSurveys({surveys}) {
    const { t } = useTranslation();
    return (
        <div className="interests-block">
            <h5>{t('surveys.interestedSurveys')}</h5>
            <ol>
                {
                    surveys.map(survey =>
                        <li key={uuidv4()}>
                            <a href={"/surveys/" + survey.id}>{survey.title}</a>
                        </li>
                    )
                }
            </ol>
        </div>
    );
}
